export enum HarvestingPlanType {
  EQ_LTCG = 'EQ_LTCG',
  EQ_LTCL = 'EQ_LTCL',
  EQ_STCG = 'EQ_STCG',
  EQ_STCL = 'EQ_STCL',
  NEQ_LTCG = 'NEQ_LTCG',
  NEQ_LTCL = 'NEQ_LTCL',
  NEQ_STCG = 'NEQ_STCG',
  NEQ_STCL = 'NEQ_STCL',
  ALL_OPTIMIZED = 'ALL_OPTIMIZED'
}

export interface BaseFinancialPlanResponse {
  folioTaxHarvestingType: HarvestingPlanType
  possibleFolioTaxHarvestingTypes: HarvestingPlanType[]
  currentEquityGain: number
  equityTaxLiability: number
  possibleTaxSave: number
  taxRate: number
}

export interface LtcgFinancialPlanResponse extends BaseFinancialPlanResponse {
  /** Legacy fields kept for backward compatibility */
  isEligibleForPlan?: boolean
  totalExemption?: number
  equityGain?: number
  taxFreeBookAmount?: number
  gainBookAmount?: number
}

export interface StcgFinancialPlanResponse extends BaseFinancialPlanResponse {
  /** Legacy fields kept for backward compatibility */
  isEligibleForPlan?: boolean
  equityGain?: number
  taxFreeBookAmount?: number
  gainBookAmount?: number
}

export interface TaxHarvestingSummaryResponse {
  stcgOffsettingNeqLtcg: number
  stcgOffsettingEqLtcg: number
  equityStcgRate: number
  equityLtcgRate: number
  nonEquityStcgRate: number
  nonEquityLtcgRate: number
  netCapitalGains: number
  totalTaxLiability: number
  netRealisedLtcg: number
  netRealisedStcg: number
  taxLiabilityLtcg: number
  taxLiabilityStcg: number
  equityStcl: number
  equityLtcl: number
  equityStcg: number
  equityLtcg: number
  nonEquityLtcg: number
  nonEquityStcg: number
  nonEquityStcl: number
  nonEquityLtcl: number
  ltcgFinancialPlanResponses: LtcgFinancialPlanResponse[]
  stcgFinancialPlanResponses: StcgFinancialPlanResponse[]
  totalExemption: number
  usedExemption: number
  taxLiabilityEquityLtcg: number
  taxLiabilityNonEquityLtcg: number
  taxLiabilityEquityStcg: number
  taxLiabilityNonEquityStcg: number
  isUserElite: boolean
  lastFetchedTimestamp: number
  ltcgFinancialPlans: Record<string, LtcgFinancialPlanResponse>
  stcgFinancialPlans: Record<string, StcgFinancialPlanResponse>
  currentFy: string
  currentFyStart: number
  currentFyEnd: number
  taxFreeBookAmount: number
  longTermGainsSummary: {
    equityLtcg: number
    nonEquityLtcg: number
    equityLtcl: number
    nonEquityLtcl: number
    netEquityLtcg: number
    netNonEquityLtcg: number
    ltclOffsettingNeqLtcg: number
    ltclOffsettingEqLtcg: number
    stclOffsettingNeqLtcg: number
    stclOffsettingEqLtcg: number
  }
  shortTermGainsSummary: {
    equityStcg: number
    nonEquityStcg: number
    equityStcl: number
    nonEquityStcl: number
    netEquityStcg: number
    netNonEquityStcg: number
    stclOffsettingNeqStcg: number
    stclOffsettingEqStcg: number
  }
}

export enum GainType {
  LTCG = 'LTCG',
  STCG = 'STCG'
}
